import React, { useEffect, useState } from "react";
import Stack from "@mui/material/Stack";
import CustomTopButton from "../components/Dashboard/TopButton";
import CustomButton from "../components/Dashboard/Button";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import FeedOutlinedIcon from "@mui/icons-material/FeedOutlined";
import { BLACK, DASHBOARD_SECONDARY, IRIS_60 } from "../colors";
import UserDetailsCard from "../components/Dashboard/UserDetailsCard";
import HeightBox from "../components/HeightBox";
import Graph from "../components/Dashboard/Graph";
import TextField from "@mui/material/TextField";
import WorldMap from "../components/Dashboard/WorldMap";
import GenderDistrib from "../components/Dashboard/GenderDistrib";
import FormEditService from "../services/formEditService";
import CustomerService from "../services/customerService";
import FinService from "../services/finService";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { styled } from "@mui/material/styles";
import { WHITE, PRIMARY_LIGHT_BLUE } from "../colors";
import NewApplication from "../components/Dashboard/NewApplications";
import CustomerByStatus from "../components/Dashboard/CustomerByStatus";
import { getAllCustomers } from "../actions/customers";
import { useDispatch, useSelector } from "react-redux";
import { getAllFinances } from "../actions/finances";
import { DateTime } from "luxon";
import WidgetEarningsImg from "../images/widget-earnings.svg";
import WidgetExpensesImg from "../images/widget-expenses.svg";
import WidgetCustomer from "../images/widget-customer.png";
import WidgetImmigrants from "../images/widget-immigrants.svg";
import WidgetApplications from "../images/widget-applications.svg";
import { getAllEmployees } from "../actions/employees";
import { getAllInquiries, getAllInquiryTypes } from "../actions/inquiries";
import { getAllRoles } from "../actions/roles";
import { getJobOrdersAction } from "../apps/jobOrders/actions";
import { filterCandidateAction } from "../apps/hunting/actions";

const CustomTextField = styled(TextField)(({ theme }) => ({
  width: 240,
  backgroundColor: WHITE,
  outline: "none",
  borderRadius: 10,
  border: "0px solid #fff",
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
  "&:hover": {
    border: "0px solid #484850",
  },
  "&:focus-within": {
    border: "0px solid #484850",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
}));

var f = { month: "long", day: "numeric", year: "numeric" };

const Dashboard = () => {
  const dispatch = useDispatch();

  const customerList = useSelector((state) => state.customerList);
  const candidates = useSelector(state=> state?.filtered)

  const {
    customers: customersStore,
    loading: customerStoreLoading,
    error: customerStoreError,
  } = customerList;
  const financeList = useSelector((state) => state.financeList);
  const { finances } = financeList;
  const [clickedButton, setClickedButton] = useState(null);
  const [screenInfo, setScreenInfo] = useState({
    screenName: "",
    customers: [],
    userData: [],
    totalExpense: 0,
    totalIncome: 0,
    filteredCustomer: [],
    filteredFinances: [],
  });

  const [searchParams, setSearchParams] = useState({
    startDate: "",
    endDate: "",
  });
  const [corruptedNICCount, setCorruptedNICCount] = useState(0);

  useEffect(() => {
    dispatch(getAllEmployees())
    dispatch(getAllInquiries())
    dispatch(getAllInquiryTypes())
    dispatch(getAllRoles())
    dispatch(getJobOrdersAction())
    dispatch(filterCandidateAction({}))
  
    
    const getPageInfo = async () => {
      if (customersStore === null) {
        dispatch(getAllCustomers());
      }
      if (finances === null) {
        dispatch(getAllFinances());
      }
      var allExp = 0;
      var allIncome = 0;
      finances?.forEach((fin) => {
        if (fin.isExpense) {
          allExp += Number(fin.amount);
        } else {
          allIncome += Number(fin.amount);
        }
      });

      const candidatesWithShortNIC = candidates?.candidates?.filter(candidate => !candidate.nic | candidate.nic.length < 5);
      const count = candidatesWithShortNIC.length;
      setCorruptedNICCount(count);
      var totalEarning = (allIncome.toFixed(2) - allExp.toFixed(2)).toFixed(2);
      setScreenInfo({
        ...screenInfo,
        customers: customersStore,
        filteredCustomer: customersStore,
        filteredFinances: finances,
        totalExpense: allExp.toFixed(2),
        totalIncome: totalEarning,
        userData: [
          {
            id: 1,
            title: "Total Candidates",
            amount: candidates?.candidates?.length,
            Icon: <PeopleOutlineIcon fontSize="16px" />,
            bgImg: WidgetCustomer,
          },
          {
            id: 2,
            title: "Current Interviews",
            amount: customersStore?.filter((cust) => cust.status === 0).length,
            Icon: <FeedOutlinedIcon fontSize="16px" />,
            bgImg: WidgetApplications,
          },
          {
            id: 2,
            title: "Total Hires",
            amount: "Not available",
            Icon: null,
            bgImg: WidgetImmigrants,
          },
          {
            id: 3,
            title: "Total Expenses",
            amount: allExp.toFixed(2),
            Icon: null,
            bgImg: WidgetExpensesImg,
          },
          {
            id: 4,
            title: "Total Earnings",
            amount: totalEarning,
            Icon:
              totalEarning > 0 ? (
                <ArrowDropUpIcon fontSize="large" color="success" />
              ) : (
                <ArrowDropDownIcon fontSize="large" color="error" />
              ),
            bgImg: WidgetEarningsImg,
          },
        ],
      });
    };

    getPageInfo();
  }, [customersStore, finances]);
  useEffect(() => {}, [screenInfo.userData]);

  useEffect(() => {
    let filteredCustomers = customersStore;
    let filteredFinances = finances;
    if (searchParams.startDate !== "") {
      filteredFinances = filteredFinances.filter(
        (fin) =>
          DateTime.fromISO(fin.createdAt).toISO(DateTime.DATE_SHORT) >=
          DateTime.fromISO(searchParams.startDate).toISO(DateTime.DATE_SHORT)
      );
      filteredCustomers = filteredCustomers.filter(
        (cust) =>
          DateTime.fromISO(cust.createdAt).toISO(DateTime.DATE_SHORT) >=
          searchParams.startDate
      );
    }
    if (searchParams.endDate !== "") {
      filteredFinances = filteredFinances.filter(
        (fin) =>
          DateTime.fromISO(fin.createdAt).toISO(DateTime.DATE_SHORT) <=
          DateTime.fromISO(searchParams.endDate).toISO(DateTime.DATE_SHORT)
      );

      filteredCustomers = filteredCustomers.filter(
        (cust) =>
          DateTime.fromISO(cust.createdAt).toISO(DateTime.DATE_SHORT) <=
          searchParams.endDate
      );
    }
    if (searchParams.endDate !== "" || searchParams.startDate !== "") {
      var allExp = 0;
      var allIncome = 0;
      filteredFinances?.forEach((fin) => {
        if (fin.isExpense) {
          allExp += Number(fin.amount);
        } else {
          allIncome += Number(fin.amount);
        }
      });

      var totalEarning = (allIncome.toFixed(2) - allExp.toFixed(2)).toFixed(2);
      setScreenInfo({
        ...screenInfo,
        filteredCustomer: filteredCustomers,
        filteredFinances: filteredFinances,
        totalExpense: allExp.toFixed(2),
        totalIncome: totalEarning,
        userData: [
          {
            id: 1,
            title: "Total Candidates",
            amount: filteredCustomers?.length,
            Icon: <PeopleOutlineIcon fontSize="16px" />,
            bgImg: WidgetCustomer,
          },
          {
            id: 2,
            title: "Current Applicants",
            amount: filteredCustomers?.filter((cust) => cust.status === 0)
              .length,
            Icon: <FeedOutlinedIcon fontSize="16px" />,
            bgImg: WidgetApplications,
          },
          {
            id: 2,
            title: "Jobs Recieved",
            amount: "Not available",
            Icon: null,
            bgImg: WidgetImmigrants,
          },
          {
            id: 3,
            title: "Total Expenses",
            amount: allExp.toFixed(2),
            Icon: null,
            bgImg: WidgetExpensesImg,
          },
          {
            id: 4,
            title: "Total Earnings",
            amount: totalEarning,
            Icon:
              totalEarning > 0 ? (
                <ArrowDropUpIcon fontSize="large" color="success" />
              ) : (
                <ArrowDropDownIcon fontSize="large" color="error" />
              ),

            bgImg: WidgetEarningsImg,
          },
        ],
      });
    }
  }, [searchParams]);

  function buttonClicked(id) {
    setClickedButton(id);
  }



  const clearSearch = () => {
    var allExp = 0;
    var allIncome = 0;
    finances?.forEach((fin) => {
      if (fin.isExpense) {
        allExp += Number(fin.amount);
      } else {
        allIncome += Number(fin.amount);
      }
    });

    var totalEarning = (allIncome.toFixed(2) - allExp.toFixed(2)).toFixed(2);
    setScreenInfo({
      ...screenInfo,
      filteredCustomer: customersStore,
      filteredFinances: finances,
      totalExpense: allExp.toFixed(2),
      totalIncome: totalEarning,
      userData: [
        {
          id: 1,
          title: "Total Candidates",
          amount: customersStore?.length,
          Icon: <PeopleOutlineIcon fontSize="16px" />,
          bgImg: WidgetCustomer,
        },
        {
          id: 2,
          title: "Current Applicants",
          amount: customersStore?.filter((cust) => cust.status === 0).length,
          Icon: <FeedOutlinedIcon fontSize="16px" />,
          bgImg: WidgetApplications,
        },
        {
          id: 2,
          title: "Jobs Recieved",
          amount: "Not available",
          Icon: null,
          bgImg: WidgetImmigrants,
        },
        {
          id: 3,
          title: "Total Expenses",
          amount: allExp.toFixed(2),
          Icon: null,
          bgImg: WidgetExpensesImg,
        },
        {
          id: 4,
          title: "Total Earnings",
          amount: totalEarning,
          Icon:
            totalEarning > 0 ? (
              <ArrowDropUpIcon fontSize="large" color="success" />
            ) : (
              <ArrowDropDownIcon fontSize="large" color="error" />
            ),
          bgImg: WidgetEarningsImg,
        },
      ],
    });
    setSearchParams({
      startDate: "",
      endDate: "",
    });
  };

  const setToLast7Days = () => {
    setSearchParams({
      startDate: DateTime.now()
        .minus({ days: 7 })
        .toISO(DateTime.DATE_SHORT)
        .split("T")[0],
      endDate: DateTime.now().toISO(DateTime.DATE_SHORT).split("T")[0],
    });
  };

  const setToLast12Months = () => {
    setSearchParams({
      startDate: DateTime.now()
        .minus({ months: 12 })
        .toISO(DateTime.DATE_SHORT)
        .split("T")[0],
      endDate: DateTime.now().toISO(DateTime.DATE_SHORT).split("T")[0],
    });
  };

  const setToLast5Years = () => {
    setSearchParams({
      startDate: DateTime.now()
        .minus({ years: 5 })
        .toISO(DateTime.DATE_SHORT)
        .split("T")[0],
      endDate: DateTime.now().toISO(DateTime.DATE_SHORT).split("T")[0],
    });
  };

  const topButtons = [
    { text: "Last 7 days", id: "1", onClickFunc: setToLast7Days },
    { text: "Last 12 months", id: "2", onClickFunc: setToLast12Months },
    { text: "Last 5 years", id: "3", onClickFunc: setToLast5Years },
  ];

  //lates analytics


  return (
    <div>
      <div>
        {/* <Stack direction="row" alignItems="center" spacing={3}>
          {topButtons?.map((item) => (
            <CustomTopButton
              key={item.id}
              text={item.text}
              clicked={clickedButton === item.id}
              id={item.id}
              onClicked={() => {
                buttonClicked(item.id);
                item.onClickFunc();
              }}
              clickedTextColor={BLACK}
              notClickedTextColor={DASHBOARD_SECONDARY}
              fontSize={14}
            />
          ))}
          <CustomTextField
            type="date"
            size="small"
            value={searchParams.startDate}
            onChange={(e) => {
              setClickedButton(null);
              setSearchParams({ ...searchParams, startDate: e.target.value });
            }}
          />

          <CustomTextField
            type="date"
            size="small"
            value={searchParams.endDate}
            onChange={(e) => {
              setClickedButton(null);
              setSearchParams({ ...searchParams, endDate: e.target.value });
            }}
          />
          <CustomButton
            text="Clear Filters"
            onClick={() => {
              clearSearch();
              setClickedButton(null);
            }}
          />
        </Stack> */}
      </div>
      {/* <HeightBox height={24} /> */}
      <div>
      {corruptedNICCount > 0 && (
        <p style={{ color: 'red' }}>
          There are {corruptedNICCount} candidates registered with invalid NIC Number!
          Please correct them to get the maximum benefit of analytics.
        </p>
      )}
    </div>
      <div>
        <Stack direction="row" alignItems="center" spacing={3}>
          {!customerStoreError &&
            !customerStoreLoading &&
            screenInfo?.userData?.map((item, index) => (
              <UserDetailsCard
                title={item.title}
                amount={item.amount}
                Icon={item.Icon}
                key={index}
                bgImage={item.bgImg}
              />
            ))}
          {screenInfo?.userData.length == 0 && (
            <>
              <UserDetailsCard />
              <UserDetailsCard />
              <UserDetailsCard />
              <UserDetailsCard />
              <UserDetailsCard />
            </>
          )}
        </Stack>
      </div>
      <HeightBox height={24} />
      <div>
        <Stack direction="row" alignItems="center" spacing={3} sx={{ mb: 3 }}>
          <GenderDistrib people={candidates?.candidates} />
          <WorldMap people={candidates?.candidates} />
          <CustomerByStatus people={screenInfo.filteredCustomer} />
        </Stack>
        <Stack direction="row" alignItems="center" spacing={3}>
          <Graph people={customersStore} />
          <NewApplication people={customersStore} />
        </Stack>
      </div>
    </div>
  );
};

export default Dashboard;
